// extracted by mini-css-extract-plugin
module.exports = {"registerForm":"register_registerForm__DP9xU","codeInput":"register_codeInput__2toh6","formStepSix":"register_formStepSix__36cga","listPassword":"register_listPassword__2jKoq"};